import React from "react";
import styles from "../styles";
import localStyles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import {
  Drop_Hook_Move_Page_Names,
  DROP_TRAILER_OPTIONS,
  STOP_TYPES,
} from "../../constants";
import constants from "../../DispatchPanel/constants";
import TrailerDropForm from "./TrailerDropForm";
import isEqual from "lodash/isEqual";
import { getEquipmentSuffix } from "../../../utils/utils";

class TrailerDropDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropType: DROP_TRAILER_OPTIONS[0].value,
      trailers: [],
      dollies: [],
      shipmentData: {},
      filteredStops: [],
      selectedTrailer: {},
      selectedDolly: {},
    };
  }

  componentDidMount() {
    this.updatedTrailersData();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.routeData, this.props.routeData)) {
      this.updatedTrailersData();
    }
  }

  clearSelectedEquipments = () => {
    this.setState({ 
      selectedTrailer: {},
      selectedDolly: {},
    });
  }

  updatedTrailersData = () => {
    const trailers = this.getCurrentTrailers();
    const dollies = this.getCurrentDollies();
    this.setState({
      trailers,
      dollies,
      selectedTrailer: trailers.length ? trailers[0] : {},
    });
  };

  onDropTypeChange = (option) => {
    if (!option) {
      return;
    }
    this.setState({
      dropType: option.value,
    });
  };

  onTrailerNumberChange = (option) => {
    this.setState({
      selectedTrailer: option ?? {},
    });
  };

  onDollyNumberChange = (option) => {
    this.setState({
      selectedDolly: option ?? {},
    });
  };

  getCurrentTrailers = () => {
    return this.props.currentDriverRoutes
      .filter(
        (route) =>
          route.trailerNumber &&
          route.trailerNumber !== constants.TRAILER_NUMBER_FOR_BOBTAIL &&
          !route.isStraightTruck
      )
      .map(({
        trailerNumber,
        trailerScac,
        trailerId,
      }) => {
        return {
          label: trailerNumber,
          value: trailerNumber,
          trailerId,
          labelSuffix: getEquipmentSuffix({
            equipmentScac: trailerScac,
            showTrailerScac: this.props.showTrailerScac,
          }),
        };
      });
  };

  getCurrentDollies = () => {
    return this.props.currentDriverRoutes
      .filter((route) => route.dollyNumber)
      .map(({
        dollyNumber,
        dollyScac,
        dollyId,
      }) => {
        return {
          label: dollyNumber,
          value: dollyNumber,
          dollyId,
          labelSuffix: getEquipmentSuffix({
            equipmentScac: dollyScac,
            showTrailerScac: this.props.showTrailerScac,
          }),
        };
      });
  };

  getConsolidatedRouteData = (stops) => {
    const initialData = {
      totalBills: 0,
      totalPieces: 0,
      totalHu: 0,
      totalWeight: 0,
    };

    const consolidatedArray = stops
      .filter(
        (stop) =>
          stop.stopType !== STOP_TYPES.PICKUP ||
          (stop.stopType === STOP_TYPES.PICKUP && stop.isStopCompleted)
      )
      .map((stop) => {
        const totalBills = stop.shipments.length;
        const shipmentInfo =
          stop.shipments?.reduce(
            (prevValue, currShipment) => ({
              totalWeight: prevValue.totalWeight + currShipment.weight ?? 0,
              totalPieces: prevValue.totalPieces + currShipment.pieces ?? 0,
              totalHu: prevValue.totalHu + currShipment.hu ?? 0,
            }),
            initialData
          ) ?? initialData;
        return { totalBills, ...shipmentInfo };
      });

    if (!consolidatedArray.length) {
      return initialData;
    }

    return consolidatedArray.reduce((prevValue, currvalue) => ({
      totalBills: prevValue.totalBills + currvalue.totalBills,
      totalWeight: prevValue.totalWeight + currvalue.totalWeight,
      totalPieces: prevValue.totalPieces + currvalue.totalPieces,
      totalHu: prevValue.totalHu + currvalue.totalHu,
    }));
  };

  onDropTrailer = () => {
    const {selectedTrailer: {trailerId}, selectedDolly: {dollyId}} = this.state;
    const routeByTrailerNumber = this.props.currentDriverRoutes.find(
      (route) =>
        (trailerId && route.trailerId?.toLowerCase() === trailerId?.toLowerCase()) ||
        route.dollyId?.toLowerCase() === dollyId?.toLowerCase()
    );

    const filteredStops = routeByTrailerNumber.stops.filter(
      (stop) =>
      STOP_TYPES.TERMINAL!==stop.stopType && !stop.isStopCompleted
    );

    this.setState({
      shipmentData: this.getConsolidatedRouteData(filteredStops),
      filteredStops,
    });

    this.props.setPageName(Drop_Hook_Move_Page_Names.TRAILER_DROP);
  };
  goBack = () => {
    this.props.setPageName(Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE);
  };

  getLabelByFeatureFlag = () => {
    return this.props.enableDollyDropAndHook ? 'Equipment Drop' : 'Trailer Drop';
  }

  render() {
    const { classes, isTrailerDropFormPage, routeData, isLoading, enableDollyDropAndHook } = this.props;
    const {
      dropType,
      selectedTrailer,
      selectedDolly,
      trailers,
      dollies,
      shipmentData,
      filteredStops,
    } = this.state;
    const isCurrentStraightTruck = routeData?.trailer?.isStraightTruck;
    const isSectionDisabled = (trailers.length === 0 && dollies.length) || isCurrentStraightTruck;
    const isEquipmentHookDisabled = isLoading || isSectionDisabled || Boolean(!selectedTrailer.value && !selectedDolly.value)
    return (
      <>
        <Grid
          container
          className={`${classes.containerStyle} ${
            isSectionDisabled ? classes.sectionDisabled : null
          }`}>
          {isTrailerDropFormPage ? (
            <TrailerDropForm
              trailerNumber={selectedTrailer.value}
              dollyNumber={selectedDolly.value ?? null}
              dropType={dropType}
              shipmentData={shipmentData}
              filteredStops={filteredStops}
              routeData={routeData}
              showHideLoader={this.props.showHideLoader}
              isLoading={isLoading}
              goBack={this.goBack}
              clearSelectedEquipments={this.clearSelectedEquipments}
              isDollyOnlyDrop={Boolean(!selectedTrailer.value && selectedDolly.value)}
              enableDollyDropAndHook={enableDollyDropAndHook}
              showTrailerScac={this.props.showTrailerScac}
            />
          ) : (
            <Grid xs={12}>
              <div className={classes.sectionTitle}>
                {this.getLabelByFeatureFlag()}
              </div>
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: 'DropType',
                    label: 'Drop Type',
                    variant: 'outlined'
                  }}
                  rootClass={classes.selectRoot}
                  value={dropType}
                  onChange={this.onDropTypeChange}
                  isNotClearable
                  data={DROP_TRAILER_OPTIONS}
                />
              </div>
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: 'TrailerNumber',
                    label: 'Trailer Number',
                    variant: 'outlined'
                  }}
                  rootClass={classes.selectRoot}
                  value={selectedTrailer.value}
                  onChange={this.onTrailerNumberChange}
                  data={trailers}
                />
              </div>
              {enableDollyDropAndHook && (
                <div className={classes.flexRow}>
                  <Select
                    textFieldProps={{
                      id: 'hookDollyList',
                      label: 'Dolly Number',
                      variant: 'outlined'
                    }}
                    rootClass={classes.selectRoot}
                    value={selectedDolly.value}
                    onChange={this.onDollyNumberChange}
                    data={dollies}
                  />
                </div>
              )}
              <div className={classes.actionButtons}>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.confirmButton}
                  onClick={this.onDropTrailer}
                  disabled={isEquipmentHookDisabled}
                  classes={{
                    disabled: classes.disabledConfirmButton
                  }}>
                  {this.getLabelByFeatureFlag()}
                </Button>
              </div>
            </Grid>
          )}
        </Grid>
      </>
    );
  }
}

export default compose(
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  ),
)(TrailerDropDialog);
